import React from 'react';
import { Link } from 'react-router-dom';
import LogoImg from '../ChatGPT Image Jun 26, 2025, 12_35_25 AM.png';

const FooterLogo = () => (
  <span className="flex items-center" style={{ alignItems: 'center' }}>
    <img src={LogoImg} alt="DevelloTech Logo" style={{ width: 32, height: 32, objectFit: 'contain', marginRight: 0, padding: 0, display: 'block' }} />
    <span
      className="text-lg font-bold tracking-tight"
      style={{
        background: 'linear-gradient(90deg, #1761A0 0%, #2ED8C3 100%)',
        WebkitBackgroundClip: 'text',
        WebkitTextFillColor: 'transparent',
        backgroundClip: 'text',
        color: 'transparent',
        marginLeft: -4,
        paddingLeft: 0,
      }}
    >
      DevelloTech
    </span>
  </span>
);

const Footer = () => {
  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  return (
    <footer className="bg-gray-900 text-white py-10">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex flex-col gap-10 md:flex-row md:items-start md:justify-between md:gap-8">
          {/* Logo + copyright — stacked on small screens so nothing overlaps */}
          <div className="flex flex-col items-center gap-3 md:items-start md:max-w-lg">
            <button
              type="button"
              className="cursor-pointer border-0 bg-transparent p-0 text-left focus:outline-none focus-visible:ring-2 focus-visible:ring-cyan-400/80"
              onClick={scrollToTop}
            >
              <FooterLogo />
            </button>
            <p className="text-center text-sm leading-relaxed text-gray-400 md:text-left">
              © {new Date().getFullYear()} DevelloTech — accurate quotes, real costs, clear profit.
            </p>
          </div>

          {/* Links — wrap cleanly on narrow phones */}
          <nav
            className="flex flex-col items-center gap-5 md:items-end"
            aria-label="Footer"
          >
            <div className="flex flex-wrap justify-center gap-x-6 gap-y-3 md:justify-end">
              <Link to="/plans" className="text-gray-300 transition-colors hover:text-white">
                Plans & pricing
              </Link>
              <Link to="/account" className="text-gray-300 transition-colors hover:text-white">
                Sign Up
              </Link>
              <Link to="/account" className="text-gray-300 transition-colors hover:text-white">
                Login
              </Link>
            </div>
            <div className="flex flex-wrap justify-center gap-x-6 gap-y-2 md:justify-end">
              <Link to="/terms-of-service" className="text-sm text-gray-400 transition-colors hover:text-white">
                Terms of Service
              </Link>
              <Link to="/privacy-policy" className="text-sm text-gray-400 transition-colors hover:text-white">
                Privacy Policy
              </Link>
            </div>
          </nav>
        </div>
      </div>
    </footer>
  );
};

export default Footer; 